import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const MachineModelSelection = (props) => {
  const {
    machineModels,
    selectedMachineModelDisplay,
    onBack,
    onNext,
    onValueChange,
    selectedMachineModel,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose your machine model</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Select the model of machine you want to pair the device to</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-machine-style"
            getOptionLabel={(option) => option.displayValue ?? option}
            options={machineModels}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
                onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Machine Model" />}
            value={selectedMachineModelDisplay}
            isOptionEqualToValue={(option, value) => option.displayValue === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedMachineModel,
          })}
          disabled={!selectedMachineModel}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default MachineModelSelection;
